import React from "react";
import { Field } from "formik";
import GridTable from "pages/_components/GridTable/GridTable";
import Checkbox from "pages/_components/Checkbox";
import { arrayOf, number, string } from "prop-types";
import * as i18n from "util/i18n";

const FORM_ID = "comex.ddjj.general";

const isValidDecimal = (value) => /^\d*\.?\d*$/.test(value);

const DDJJSubOptionsV14 = ({ rowStart, subOptions }) => {
    if (!subOptions?.length) {
        return null;
    }

    return subOptions.map((subOption, index) => {
        const row = rowStart + index;
        const className = index === 0 ? "ddjj-suboption-top" : "ddjj-suboption-bottom";

        return (
            <GridTable.Data
                flexDirection="column"
                columnStart={2}
                columnWidth={10}
                rowStart={row}
                key={`v14-${subOption}`}
                className={className}>
                <div className="inline-checkbox">
                    <Field name={`v14.${subOption}.checked`}>
                        {({ field, form }) => {
                            const handleChange = (checked) => {
                                const currentGroup = form.values?.v14 || {};
                                const updated = Object.keys(currentGroup).reduce((acc, key) => {
                                    acc[key] = {
                                        ...currentGroup[key],
                                        checked: key === subOption ? checked : false,
                                        value: currentGroup[key]?.value || "",
                                    };
                                    return acc;
                                }, {});

                                form.setFieldValue("v14", updated);
                            };

                            return (
                                <Checkbox
                                    {...field}
                                    idForm={FORM_ID}
                                    name={field.name}
                                    checked={field.value}
                                    onChange={handleChange}
                                />
                            );
                        }}
                    </Field>
                    <div className="ddjj-inline-content">
                        <p className="ddjj-item">
                            {i18n.get("comex.currency.usd.prefix")}
                            <Field name={`v14.${subOption}.value`}>
                                {({ field, form }) => (
                                    <input
                                        id={`v14.${subOption}.value`}
                                        className="inline-input"
                                        type="text"
                                        maxLength={14}
                                        value={field.value || ""}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (isValidDecimal(val)) {
                                                form.setFieldValue(field.name, val);
                                            }
                                        }}
                                        onBlur={field.onBlur}
                                    />
                                )}
                            </Field>

                            {i18n.get(`${FORM_ID}.v14.${subOption}.label`)}
                        </p>
                    </div>
                </div>
            </GridTable.Data>
        );
    });
};

DDJJSubOptionsV14.propTypes = {
    rowStart: number.isRequired,
    subOptions: arrayOf(string).isRequired,
};

export default DDJJSubOptionsV14;
